"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voice-chat.error.noModelOrAvatar': 'Seleziona un modello o avatar per iniziare la conversazione vocale.',
};
